import { SVGProps } from 'react';

/** Generic picture-frame icon used for all image extensions (.png / .jpg / .jpeg / .tif / .tiff). */
export const ImageIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 -35.5 169 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="40.5" cy="38.5" r="11.5" fill="#009684" />
      <path
        d="M10.5 97L101.322 35.6833C105.845 32.6298 111.859 33.0126 115.958 36.6149L158.5 74"
        stroke="#009684"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <rect x="7" y="7" width="155" height="110" rx="20" stroke="#009684" strokeWidth="14" />
    </svg>
  );
};
